import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Old WordPress pagination, /hair-loss-blog/page/<n>/. The blog index loads
// more posts in place, so send every page number to the index. Keep the
// query string so ad and UTM tags survive.
export const Route = createFileRoute("/hair-loss-blog/page/$")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/hair-loss-blog/", location.searchStr), statusCode: 301 });
  },
});
